import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  .ant-input,
  ant-input:focus {
    border: none;
  }

  .ant-input:focus,
  .ant-input-focused {
    box-shadow: none !important;
    outline: none !important;
  }
`;
